module.exports = __webpack_public_path__ + "static/media/zoom-out.19db3f51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/maps/zoom-out.svg
// module id = 964
// module chunks = 0